// import node module libraries
import { createSlice } from "@reduxjs/toolkit";

const extraSlice = createSlice({
  name: "extra",
  initialState: {
    userImage: "",
    isProfileEditing: false,
  },
  reducers: {
    changeUserImage: (state, action) => {
      state.userImage = action.payload;
    },

    setIsProfileEditing: (state, action) => {
      state.isProfileEditing = action.payload;
    },
    toggleProfileEditing: (state) => {
      state.isProfileEditing = !state.isProfileEditing;
    },
  },
});

export const { changeUserImage, setIsProfileEditing, toggleProfileEditing } =
  extraSlice.actions;
export default extraSlice.reducer;
